import { useEffect } from 'react';
import { useI18n } from '../i18n/useI18n';
import { socialAssets } from '../data/websiteAssets';

export function useSeo(titleKey: string, descriptionKey: string) {
  const { t, language } = useI18n();

  useEffect(() => {
    const title = t(titleKey);
    const description = t(descriptionKey);
    const socialImage = new URL(socialAssets.get(language).png, window.location.origin).href;
    document.documentElement.lang = language;
    document.title = title;
    setMeta('description', description);
    setProperty('og:title', title);
    setProperty('og:description', description);
    setProperty('og:url', window.location.href);
    setProperty('og:image', socialImage);
    setMeta('twitter:image', socialImage);
  }, [descriptionKey, language, t, titleKey]);
}

function setMeta(name: string, value: string) {
  const meta = document.querySelector(`meta[name="${name}"]`);
  if (meta) {
    meta.setAttribute('content', value);
  }
}

function setProperty(property: string, value: string) {
  const meta = document.querySelector(`meta[property="${property}"]`);
  if (meta) {
    meta.setAttribute('content', value);
  }
}
